'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ReplySubmit = require('./ReplySubmit.scss');

var _ReplySubmit2 = _interopRequireDefault(_ReplySubmit);

var _media = require('utils/media');

var _reactRedux = require('react-redux');

var _actions = require('redux/modules/booking/actions');

var _reactIntl = require('react-intl');

var _LoadingButton = require('components/Loader/LoadingButton');

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ReplySubmit: {
    displayName: 'ReplySubmit'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReplySubmit.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var ReplySubmit = _wrapComponent('ReplySubmit')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sending: state.booking.sending
  };
}, { replyReview: _actions.replyReview }), _dec2 = (0, _reactCssModules2.default)(_ReplySubmit2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ReplySubmit, _Component);

  function ReplySubmit() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReplySubmit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReplySubmit.__proto__ || (0, _getPrototypeOf2.default)(ReplySubmit)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      text: ''
    }, _this.onChange = function (event) {
      _this.setState({ text: event.target.value });
    }, _this.submit = function () {
      _this.props.replyReview(_this.props.review._id, _this.state.text).then(function () {
        return _this.props.onSubmit(_this.state.text);
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReplySubmit, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var text = this.state.text;
      var _props = this.props,
          replier = _props.replier,
          sending = _props.sending;

      var defaultImage = require('theme/images/default-img.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'reply-submit-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'replier' },
          _react3.default.createElement(
            'div',
            { styleName: 'replier-pic' },
            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
          ),
          _react3.default.createElement(
            'span',
            { className: 'replier-user-name', styleName: 'replier-user-name' },
            replier && replier.name && '' + replier.name.first
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'reply-box-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'textbox-container' },
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement('textarea', { styleName: 'textbox', value: text, onChange: this.onChange }),
              function () {
                if (text) {
                  if (sending) {
                    return _react3.default.createElement(
                      'a',
                      { styleName: 'btn-reply-loading' },
                      _react3.default.createElement(_LoadingButton2.default, null),
                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.loading.button' })
                    );
                  }
                  return _react3.default.createElement(
                    'a',
                    { styleName: 'btn-reply-submit', onMouseDown: _this2.submit },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.submit.button' })
                  );
                }
                return _react3.default.createElement(
                  'a',
                  { styleName: 'btn-reply-disable' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.disable.button' })
                );
              }()
            )
          )
        )
      );
    }
  }]);
  return ReplySubmit;
}(_react2.Component), _class2.propTypes = {
  review: _react2.PropTypes.object,
  replier: _react2.PropTypes.object,
  sending: _react2.PropTypes.bool,
  replyReview: _react2.PropTypes.func,
  onSubmit: _react2.PropTypes.func
}, _temp2)) || _class) || _class));

exports.default = ReplySubmit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/ReplySubmit.js
// module id = 261
// module chunks = 0 2 9